import { IUploadFileResponse } from '~/utils/interface/file';
import axiosClient from './axiosClient';

const fileApi = {
  uploadFiles(data: FormData) {
    return axiosClient.post<IUploadFileResponse>('api/files/upload', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
export default fileApi;
